const PROFILE_STATUS = {
    pending: 1,
    contractPending: 2,
    costObjectPending: 3,
    completed: 4
  };
  
  export default PROFILE_STATUS;